"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "home_container",
    attrs: {
      id: "home"
    }
  }, [_c("div", {
    ref: "cont-01",
    staticClass: "cont-01 relative scroll-section",
    class: {
      "animate-in": _vm.sectionAnimations.cont01
    },
    attrs: {
      "data-section": "cont01"
    }
  }, [_c("top-nav"), _c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E9%A6%96%E9%A1%B5%E5%B0%81%E9%9D%A2-bg%402x.png"
    }
  }), _c("div", {
    staticClass: "banner-content flex-column-center"
  }, [_vm._m(0), _c("div", {
    staticClass: "data-board slide-up-text delay-1",
    class: {
      "fly-in": _vm.dataBoardAnimated
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("累计发布货源")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.huoyuan.value))), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.huoyuan.unit))])])]), _c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("货主用户")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.huozhu.value)) + "+"), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.huozhu.unit))])])]), _c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("日均货源")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.rjhuoyuan.value)) + "+"), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.rjhuoyuan.unit))])])])], 1), _c("el-row", {
    staticClass: "mt-40",
    attrs: {
      gutter: 40
    }
  }, [_c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("累计发布车源")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.che.value))), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.che.unit))])])]), _c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("认证司机")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.siji.value)) + "+"), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.siji.unit))])])]), _c("el-col", {
    staticClass: "data-item",
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("每日实时在线接单车辆")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.dataBoard.onlineCar.value)) + "+"), _c("span", {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.dataBoard.onlineCar.unit))])])])], 1)], 1)])], 1), _c("div", {
    ref: "cont-02",
    staticClass: "cont-02 flex-col-start align-item-center scroll-section",
    class: {
      "animate-in": _vm.sectionAnimations.cont02
    },
    style: {
      backgroundImage: "url('".concat(_vm.backgroundImages[_vm.currentIndex], "')")
    },
    attrs: {
      "data-section": "cont02"
    }
  }, [_c("div", {
    staticClass: "data-board-bottom"
  }, [_c("div", {
    staticClass: "title slide-up-text"
  }, [_vm._v(_vm._s(_vm.dataBoardBottomTexts[_vm.currentIndex].title))]), _c("div", {
    staticClass: "title_content slide-up-text delay-1"
  }, _vm._l(_vm.dataBoardBottomTexts[_vm.currentIndex].content, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s(item)), index < _vm.dataBoardBottomTexts[_vm.currentIndex].content.length - 1 ? _c("span", {
      staticClass: "spacing"
    }) : _vm._e()]);
  }), 0), _c("div", {
    staticClass: "title_content-desc slide-up-text delay-2"
  }, _vm._l(_vm.dataBoardBottomTexts[_vm.currentIndex].desc, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c("div", {
    staticClass: "cont-02-content"
  }, [_c("div", {
    staticClass: "content-left",
    on: {
      click: _vm.prevSlide
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%B7%A6%E7%AE%AD%E5%A4%B4%402x.png",
      alt: "bg"
    }
  }), _c("div", {
    staticClass: "text-content"
  }, [_c("span", {
    staticClass: "vertical-text-left"
  }, [_vm._v(_vm._s(_vm.sideTexts[_vm.currentIndex].left))])])]), _c("div", {
    staticClass: "content-middle"
  }, [_c("transition", {
    attrs: {
      name: "fade",
      mode: "out-in"
    }
  }, [_c("img", {
    key: _vm.currentIndex,
    staticClass: "middle-img",
    attrs: {
      src: _vm.middleImages[_vm.currentIndex],
      alt: "middle"
    }
  })]), _vm.currentIndex === 0 ? _c("div", {
    staticClass: "floating-panels"
  }, [_vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7)]) : _vm._e(), _vm.currentIndex === 3 ? _c("div", {
    staticClass: "floating-images"
  }, [_c("img", {
    staticClass: "float-img panel-tl",
    attrs: {
      src: _vm.floatingImages[0]
    }
  }), _c("img", {
    staticClass: "float-img panel-tr",
    attrs: {
      src: _vm.floatingImages[1]
    }
  }), _c("img", {
    staticClass: "float-img panel-ml",
    attrs: {
      src: _vm.floatingImages[2]
    }
  }), _c("img", {
    staticClass: "float-img panel-mr",
    attrs: {
      src: _vm.floatingImages[3]
    }
  }), _c("img", {
    staticClass: "float-img panel-bl",
    attrs: {
      src: _vm.floatingImages[4]
    }
  }), _c("img", {
    staticClass: "float-img panel-br",
    attrs: {
      src: _vm.floatingImages[5]
    }
  }), _c("img", {
    staticClass: "float-img panel-center-bottom",
    attrs: {
      src: _vm.floatingImages[6]
    }
  })]) : _vm._e()], 1), _c("div", {
    staticClass: "content-right",
    on: {
      click: _vm.nextSlide
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%8F%B3%E7%AE%AD%E5%A4%B4%402x.png",
      alt: "bg"
    }
  }), _c("div", {
    staticClass: "text-content"
  }, [_c("span", {
    staticClass: "vertical-text-right"
  }, [_vm._v(_vm._s(_vm.sideTexts[_vm.currentIndex].right))])])])])]), _c("div", {
    ref: "cont-03",
    staticClass: "cont-03 flex-col-start align-item-center scroll-section",
    class: {
      "animate-in": _vm.sectionAnimations.cont03
    },
    staticStyle: {
      background: "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E6%95%B0%E6%99%BA%E7%AE%A1%E7%90%86bg.png') no-repeat center/cover"
    },
    attrs: {
      "data-section": "cont03"
    }
  }, [_c("div", {
    staticClass: "data-board-bottom"
  }, [_c("div", {
    staticClass: "title slide-up-text"
  }, [_vm._v("数智管理")]), _vm._m(8), _vm._m(9), _c("div", {
    staticClass: "tab-switch-area"
  }, [_c("div", {
    staticClass: "tab-list"
  }, _vm._l(_vm.dataBoardTabs, function (tab, index) {
    return _c("div", {
      key: index,
      staticClass: "tab-item",
      class: {
        active: _vm.activeTabIndex === index
      },
      on: {
        click: function click($event) {
          _vm.activeTabIndex = index;
        },
        mouseenter: function mouseenter($event) {
          _vm.hoverTabIndex = index;
        },
        mouseleave: function mouseleave($event) {
          _vm.hoverTabIndex = null;
        }
      }
    }, [_c("div", {
      staticClass: "tab-title"
    }, [_vm._v(_vm._s(tab.title))]), _c("div", {
      staticClass: "tab-subtitle"
    }, [_vm._v(_vm._s(tab.subtitle))])]);
  }), 0), _c("div", {
    staticClass: "tab-content-wrapper"
  }, [_c("div", {
    staticClass: "tab-content"
  }, [_c("div", {
    staticClass: "click-zone left-zone",
    on: {
      click: _vm.prevTab
    }
  }), _c("img", {
    staticClass: "tab-image",
    attrs: {
      src: _vm.dataBoardTabs[_vm.hoverTabIndex !== null ? _vm.hoverTabIndex : _vm.activeTabIndex].image,
      alt: ""
    }
  }), _c("div", {
    staticClass: "click-zone right-zone",
    on: {
      click: _vm.nextTab
    }
  })])])])])]), _c("div", {
    ref: "cont-04",
    staticClass: "cont-04 flex-col-start align-item-center scroll-section",
    class: {
      "animate-in": _vm.sectionAnimations.cont04
    },
    staticStyle: {
      background: "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E7%94%9F%E6%80%81%E7%BD%91%E7%BB%9Cbg.png') no-repeat center/cover"
    },
    attrs: {
      "data-section": "cont04"
    }
  }, [_c("div", {
    staticClass: "text-center slide-up-text"
  }, [_vm._v("生态网络")]), _vm._m(10), _c("div", {
    staticClass: "text-center-content slide-up-text delay-2"
  }, [_vm._v(" 依托数字化、信息化、智能化等技术手段，建成集化工企业、园区、贸易、物流、仓储、商务、软件系统等 全场景为一体数字生态，实现全场景、全链条高效对接 ")]), _vm._m(11)]), _c("div", {
    ref: "cont-05",
    staticClass: "cont-05 flex-col-start align-item-center scroll-section",
    class: {
      "animate-in": _vm.sectionAnimations.cont05
    },
    staticStyle: {
      background: "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%BB%BC%E5%90%88%E6%9C%8D%E5%8A%A1bg.png') no-repeat center/cover"
    },
    attrs: {
      "data-section": "cont05"
    }
  }, [_c("div", {
    staticClass: "text-center slide-up-text"
  }, [_vm._v("综合服务")]), _vm._m(12), _vm._m(13), _c("div", {
    staticClass: "more-service-btn",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.moreInfo.apply(null, arguments);
      }
    }
  }, [_vm._v("更多服务")])]), _vm._m(14)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-img-box text-center slide-up-text"
  }, [_c("img", {
    staticClass: "title-pic",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/text%402x.png",
      alt: "化工供应链一站式综合服务平台-危化镖局"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-tl"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("450")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("亿元")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("年度物流估值")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-tr"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("12634")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("万条")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("累积危运订单")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-ml"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("16")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("万+")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("认证司机")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-mr"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("50")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("万+")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("行业用户")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-bl"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("200")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("万+")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("车源路线")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-br"
  }, [_c("div", {
    staticClass: "value-box"
  }, [_c("span", {
    staticClass: "value"
  }, [_vm._v("15")]), _c("span", {
    staticClass: "unit"
  }, [_vm._v("万+")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("日更货源")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-panel panel-center-bottom"
  }, [_c("div", {
    staticClass: "center-title"
  }, [_vm._v("智慧塔")]), _c("div", {
    staticClass: "center-subtitle"
  }, [_vm._v("配载系统")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title_content slide-up-text delay-1"
  }, [_c("span", [_vm._v("全场景数字智能融为一体")]), _c("span", {
    staticClass: "spacing"
  }), _c("span", [_vm._v("赋能物流企业降本增效")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title_content-desc slide-up-text delay-2"
  }, [_c("div", [_vm._v("基于大数据、云计算、AI模型等技术，链接平台多年沉淀的全国化工园区、客户、货源、车源与轨迹、仓储、")]), _c("div", [_vm._v("招投标、保险、软件系统等危化品物流全场景数据资源，以智慧应用，构筑企业降本增效全新样板")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-center-middle slide-up-text delay-1"
  }, [_c("span", [_vm._v("多年持续深耕行业")]), _c("span", {
    staticClass: "spacing"
  }), _c("span", [_vm._v("缔造生态服务网络")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      padding: "0 70px"
    }
  }, [_c("img", {
    staticClass: "item-r",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E7%94%9F%E6%80%81%E7%BD%91%E7%BB%9C%E6%A6%82%E5%BF%B5%E5%9B%BE.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-center-middle slide-up-text delay-1"
  }, [_c("span", [_vm._v("全场景深度支持")]), _c("span", {
    staticClass: "spacing"
  }), _c("span", [_vm._v("危化物流更美好")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      padding: "0 70px"
    }
  }, [_c("img", {
    staticClass: "item-r",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E7%BB%BC%E5%90%88%E6%9C%8D%E5%8A%A1%E6%A6%82%E5%BF%B5%E5%9B%BE.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "footer-container"
  }, [_c("div", {
    staticClass: "footer-main"
  }, [_c("div", {
    staticClass: "f-col logo-col"
  }, [_c("img", {
    staticClass: "f-logo",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-logo.png"
    }
  })]), _c("div", {
    staticClass: "f-col"
  }, [_c("img", {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E9%82%AE%E7%AE%B1%402x.png"
    }
  }), _c("div", {
    staticClass: "f-col-box"
  }, [_c("div", {
    staticClass: "f-title"
  }, [_vm._v("邮箱地址")]), _c("div", {
    staticClass: "f-text"
  }, [_vm._v("公共事务：hwc@whbj.onaliyun.com")]), _c("div", {
    staticClass: "f-text"
  }, [_vm._v("招聘联系：hr@whbj.onaliyun.com")])])]), _c("div", {
    staticClass: "f-col"
  }, [_c("img", {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AE%98%E6%96%B9%E7%BD%91%E5%9D%80%402x.png"
    }
  }), _c("div", {
    staticClass: "f-col-box"
  }, [_c("div", {
    staticClass: "f-title"
  }, [_vm._v("官方网址")]), _c("div", {
    staticClass: "f-text"
  }, [_vm._v("https://www.weihuabiaoju.com")])])]), _c("div", {
    staticClass: "f-col social-col"
  }, [_c("div", {
    staticClass: "social-icons"
  }, [_c("div", {
    staticClass: "s-icon"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%94%B5%E8%AF%9D.png",
      alt: "电话"
    }
  })]), _c("div", {
    staticClass: "s-icon"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%BE%AE%E4%BF%A1.png",
      alt: "微信"
    }
  })]), _c("div", {
    staticClass: "s-icon"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%BE%AE%E5%8D%9A.png",
      alt: "微博"
    }
  })])]), _c("div", {
    staticClass: "qr-group"
  }, [_c("div", {
    staticClass: "qr-item"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.png",
      alt: "公众号"
    }
  }), _c("span", [_vm._v("公众号二维码")])]), _c("div", {
    staticClass: "qr-item"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/app%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png",
      alt: "APP"
    }
  }), _c("span", [_vm._v("app下载二维码")])])])])]), _c("div", {
    staticClass: "footer-copy"
  }, [_vm._v(" ©fjkuu, Inc. All rights reserved. 保留所有权利 ")])]);
}];
render._withStripped = true;